import Vue from 'vue'
import ElementUI from 'element-ui';
import axios from 'axios'
import 'element-ui/lib/theme-chalk/index.css';
import VideoPlayer from 'vue-video-player'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
import App from './App.vue'
import router from './router'
import store from './store'
Vue.prototype.$axios = axios;
Vue.config.devtools = true;
axios.defaults.withCredentials=true;  //解决跨域SESSIONID不一致问题

Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.use(VideoPlayer);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
